<template>
  <div
    class="biTooltips"
    ref="biToolTip"
    v-show="data.desc.length"
    :style="{left: `${left}px`, top: `${top}px`, opacity: 0}">
    <div class="title">{{ data.title }}</div>
    <ul class="desc">
      <li
        v-if="typeof data.desc === 'object'"
        v-for="item in data.desc"
        :key="item"
        v-show="item.status">
        <em
          :class="`legend-${item.type}`"
          :style="{'background': item.type === 'dotLine' ? '' : item.color, 'border-top-color': item.type === 'dotLine' ? item.color : ''}">
          <i
            v-show="item.type === 'line'"
            :style="{'border': `2px solid ${item.color}`}"/>
        </em>
        <span>{{ item.title }}</span><strong>{{ item.value }}</strong>
      </li>
      <li
        v-if="typeof data.desc === 'string'"
        ref="desc"/>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clientWidth: 0,
      length: 0
    };
  },
  props: {
    data: {
      type: Object, default: () => ({})
    }
  },
  computed: {
    left() {
      let { panelWidth, x } = this.data;
      return x < panelWidth - this.clientWidth ? x + 20 : x - this.clientWidth - 20;
    },
    top() {
      return this.data.y;
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        this.clientWidth = this.$refs.biToolTip.clientWidth;
        if (typeof this.data.desc === 'string') {
          this.$refs.desc.innerHTML = this.data.desc;
        }
      });
    }
  }
};
</script>

<style scoped>
.biTooltips {
  position: absolute;
  top: 100px;
  left: 100px;
  z-index: 500;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(183, 183, 183, 0.25);
  border-radius: 8px;
  white-space: nowrap;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  pointer-events: none;
}

.biTooltips .title {
  padding: 4px 8px;
  line-height: 20px;
  font-weight: bold;
  background: rgba(194, 199, 214, 0.2);
}

.biTooltips .desc {
  margin: 0;
  padding: 4px;
  list-style: none;
  justify-content: space-between;
}

.biTooltips .desc li {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  padding: 2px;
  font-size: 12px;
}

.biTooltips .desc li em {
  position: relative;
  display: inline-block;
  margin-right: 4px;

}

.biTooltips .desc li em.legend-bar {
  width: 11px;
  height: 11px;
  line-height: 12px;
  vertical-align: middle;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.biTooltips .desc li em.legend-pie {
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.biTooltips .desc li em.legend-line {
  width: 12px;
  height: 2px;
}

.biTooltips .desc li em.legend-line i {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 4px;
  height: 4px;
  background: #fff;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.biTooltips .desc li em.legend-dotLine {
  width: 14px;;
  border-top-width: 2px;
  border-top-style: dotted;
  height: 0;
}

.biTooltips .desc li span {
  display: inline-block;
  font-size: 12px;
}

.biTooltips .desc li strong {
  -webkit-flex: 1;
  flex: 1;
  min-width: 2em;
  padding-left: 18px;
  font-weight: 400;
  font-size: 12px;
  text-align: right;
}

</style>
